module.exports = "/assets/images/stat_0ea35b.svg";